import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs';
import * as fileSaver from 'file-saver';
import JSZip from 'jszip';
import { DatosExcel } from '../models/datos-excel';

@Injectable({
  providedIn: 'root'
})
export class ExportadorExcelService {
  workbook: any = {};
  worksheet: any = {};
  private columns = ['A','B','C','D','E','F','G','H','I','J','K','L','M', 'N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
  columnaIncio: string= "A1" ;
  columnasExcel: any[] = [];

  constructor() { }

  exportaExcel(configuracion:DatosExcel, rows: any[]){
    this.generaBufferExcel(configuracion, rows).then((data:any) =>
    {
      let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      fileSaver.saveAs(blob, configuracion.nombreFichero);
    });
  }

  async exportaExcelZip(ficheros: { configuracion: DatosExcel; rows: any[] }[], nombreZip: string): Promise<void> {
    const zip = new JSZip();
    for (const fichero of ficheros) {
      const excelBuffer = await this.generaBufferExcel(fichero.configuracion, fichero.rows);
      zip.file(fichero.configuracion.nombreFichero, excelBuffer);
    }

    const zipBuffer = await zip.generateAsync({ type: 'blob' });
    fileSaver.saveAs(zipBuffer, nombreZip);
  }

  private async generaBufferExcel(configuracion: DatosExcel, rows: any[]): Promise<ArrayBuffer> {
    this.workbook = new Workbook();
    this.worksheet = this.workbook.addWorksheet(configuracion.workSheetName);
    this.columnasExcel = this.CargaColumnas(configuracion);
    const columnasTablaSeguras = this.getColumnasTablaSeguras(this.columnasExcel);
    const nombreTablaSeguro = this.getNombreTablaSeguro(configuracion.workSheetName);
    this.AnchoColumna();
    this.worksheet.addTable({
      name: nombreTablaSeguro,
      ref: this.columnaIncio,
      headerRow: true,
      style: {
        showRowStripes: true,
      },
      columns: columnasTablaSeguras,
      rows: rows,
    });

    this.worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
      if(rowNumber===1){
        row.eachCell({ includeEmpty: true }, (cell) => {
          cell.fill = {
            type: 'pattern',
            pattern:'solid',
            fgColor:{argb:'F7C548'},
          }
          cell.font = {
            color: { argb: '070E28' }
          }
        });

      }
      if (rowNumber % 2 === 0) {
        row.eachCell({ includeEmpty: true }, (cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFAEF' },
          };
        });
      }
    });

    return this.workbook.xlsx.writeBuffer() as Promise<ArrayBuffer>;
  }

  private getNombreTablaSeguro(workSheetName: string): string {
    const base = (workSheetName ?? 'Tabla')
      .replace(/[^A-Za-z0-9_]/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_+|_+$/g, '');
    const startsWithLetter = /^[A-Za-z]/.test(base) ? base : `T_${base}`;
    return (startsWithLetter || 'Tabla').slice(0, 255);
  }

  private getColumnasTablaSeguras(columnas: any[]): any[] {
    const usados = new Map<string, number>();
    return columnas.map((columna, index) => {
      const nombreOriginal = (columna?.name ?? `Columna_${index + 1}`).toString().trim();
      const base = nombreOriginal.length > 0 ? nombreOriginal : `Columna_${index + 1}`;
      const count = usados.get(base) ?? 0;
      usados.set(base, count + 1);
      const nombreUnico = count === 0 ? base : `${base}_${count + 1}`;
      return { ...columna, name: nombreUnico };
    });
  }

  // Cargamos las columnas del excel basandonos en las del grid
  CargaColumnas(configuracion: DatosExcel):any[]{
    let columns:any[] = [];
      configuracion.columnas.forEach((x, i) => {
        x.ColumnExcel = this.columns[i];
        columns.push(x);
    });
    return columns;
  }

  // Cargar el ancho de las columnas
 AnchoColumna(){
  this.columnasExcel.forEach(x=>{
    let col = this.worksheet.getColumn(x.ColumnExcel);
    col.width = (x.width/10);
  });
}


}
